enum Gender {
    Female,
    Male,
    Other,
    Unkown
}

export default Gender;